// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   // Modal, // Removed if not used
//   Box,
//   // Select, // Removed if not used
//   // MenuItem, // Removed if not used
//   // FormControl as MuiFormControl, // Renamed to avoid conflict
//   // InputLabel, // Removed if not used
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Checkbox,
//   Paper,
//   CircularProgress, // Added for loading indication
//   FormControl, // Keep this one for RadioGroup
//   Alert, // Added for better feedback
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import React, { useEffect, useState, useCallback } from "react"; // Added useCallback
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp"; // Assuming this component is correctly set up
// import Autocomplete from "@mui/material/Autocomplete";
// // import { Margin } from "@mui/icons-material"; // Removed if not used
// // import nopdf from "../../../assets/images/nopdf.png"; // Removed if not used

// // Removed unused style object

// type DocType = {
//   value: string;
//   label: string;
// };

// type TableRowData = {
//   id: number;
//   fileNo: string;
//   docMid: number;
//   fileDef: string;
//   isSelected: boolean;
// };

// // Define validation schema
// const validationSchema = Yup.object({
//   docID: Yup.number()
//     .min(0, "Document Type is required") // Assuming -1 is the placeholder value
//     .required("Document Type is required"),
//   // No validation needed for the table data directly in Yup here,
//   // but we'll check selection in onSubmit
// });

// const UpdatePDF: React.FC = () => { // Use React.FC for functional components
//   const navigate = useNavigate();
//   const { t } = useTranslation();

//   // State variables
//   const [tableData, setTableData] = useState<TableRowData[]>([]);
//   const [docTypeOptions, setDocTypeOptions] = useState<DocType[]>([]);
//   const [isLoadingDocTypes, setIsLoadingDocTypes] = useState<boolean>(false);
//   const [isLoadingDocs, setIsLoadingDocs] = useState<boolean>(false);
//   const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
//   const [selectedAction, setSelectedAction] = useState<string>("rename"); // 'rename' or 'shift'

//   // --- Data Fetching ---

//   const getDocType = useCallback(async () => {
//     setIsLoadingDocTypes(true);
//     const collectData = { docID: -1, parentDocId: -1, userId: "" };
//     try {
//       const response = await axios.post(
//         HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`,
//         collectData
//       );
//       if (response.data?.data) {
//         const formattedOptions: DocType[] = response.data.data.map(
//           (item: any) => ({
//             label: item["doc_Name"],
//             value: item["docID"].toString(), // Ensure value is string if needed by Autocomplete
//           })
//         );
//         // Add the placeholder option if desired, or handle selection requirement differently
//         // setDocTypeOptions([{ value: "-1", label: t("text.SelectDocType") }, ...formattedOptions]);
//         setDocTypeOptions(formattedOptions); // Better to handle required selection via validation
//       } else {
//         console.error("Failed to fetch doc types or data format incorrect");
//         toast.error("Failed Fetch DocTypes");
//       }
//     } catch (error) {
//       console.error("Error fetching doc types:", error);
//       toast.error("Failed Fetch DocTypes");
//     } finally {
//       setIsLoadingDocTypes(false);
//     }
//   }, [t]); // Add dependencies

//   useEffect(() => {
//     getDocType();
//   }, [getDocType]); // useEffect depends on getDocType

//   const fetchDocuments = async (docId: number) => {
//     if (docId < 0) {
//       setTableData([]); // Clear table if no valid doc type is selected
//       return;
//     }
//     setIsLoadingDocs(true);
//     setTableData([]); // Clear previous data
//     const collectData = {
//       docMid: -1,
//       fileTypId: docId,
//       divisionid: -1,
//       subsubjId: -1,
//       user_Id: -1, // Consider using actual user ID if available
//       fileNo: "",
//       subDeptID: -1,
//       synopsis: "",
//       complt: ""
//     };
//     try {
//       const response = await axios.post(
//         HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
//         collectData
//       );
//       if (response.data?.data) {
//         const formattedData: TableRowData[] = response.data.data.map(
//           (item: any, index: number) => ({
//             // Use index or a unique ID from data if available for the 'id' field
//             id: item["docMid"] || index, // Prefer docMid if always unique and present
//             fileNo: item["fileNo"],
//             docMid: item["docMid"],
//             fileDef: item["fileDef"],
//             isSelected: false,
//           })
//         );
//         setTableData(formattedData);
//       } else {
//         setTableData([]); // Ensure table is empty on failed fetch or no data
//         console.error("Failed to fetch documents or data format incorrect");
//         // Optionally show a toast, but the empty table message might suffice
//         // toast.warn(t("text.noDocumentsFound"));
//       }
//     } catch (error) {
//       setTableData([]);
//       console.error("Error fetching documents:", error);
//       toast.error("Fetch Documents");
//     } finally {
//       setIsLoadingDocs(false);
//     }
//   };

//   // --- Form Handling ---

//   const formik = useFormik({
//     initialValues: {
//       docID: -1, // Use number consistent with validation
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       setIsSubmitting(true);

//       const selectedFiles = tableData.filter((row) => row.isSelected);

//       if (selectedFiles.length === 0) {
//         toast.warn("no file slected");
//         setIsSubmitting(false);
//         return;
//       }

//       // Prepare payload based on the selected action
//       let payload;
//       let apiUrl;

//       if (selectedAction === "rename") {
//         payload = {
//           udatePdfFiles: selectedFiles.map((row) => ({
//             docID: row.docMid, // Assuming docMid is the ID to use for update
//             doc_Name: row.fileDef, // The potentially updated file name
//           })),
//           // Add any other required fields based on API spec
//           // e.g., fileTypId: values.docID
//         };
//         apiUrl = HOST_URL.HOST_URL2 + `DocMangr/UpdatePdfFileName`;
//       } else if (selectedAction === "shift") {
//         // --- TODO: Implement Shift Category Logic ---
//         // 1. Add a new Autocomplete/Select for the target category.
//         // 2. Update Yup validation if needed.
//         // 3. Prepare the payload for the shift API endpoint.
//         // payload = { ... };
//         // apiUrl = HOST_URL.HOST_URL2 + `YourShiftApiEndpoint`;
//         toast.info("Shift category functionality not yet implemented.");
//         setIsSubmitting(false);
//         return; // Prevent submission until implemented
//       } else {
//         toast.error("Invalid action selected.");
//         setIsSubmitting(false);
//         return;
//       }


//       try {
//         const response = await axios.post(apiUrl, payload);
//         if (response.data.isSuccess) {
//           toast.success(response.data.mesg);
//           // Reset selection and potentially refetch or clear table
//           setTableData((prev) =>
//             prev.map((row) => ({ ...row, isSelected: false }))
//           );
//           // Optionally clear the table or refetch if the underlying data might change significantly
//           // setTableData([]);
//           // formik.resetForm(); // Reset doc type selection as well? Decide based on workflow.
//           // Or just refetch for the current doc type:
//           fetchDocuments(values.docID); // Refetch to show updated names (if API returns them) or just confirm success
//         } else {
//           toast.error(response.data.mesg);
//         }
//       } catch (error) {
//         console.error("Error submitting update:", error);
//         toast.error("Update Failed Generic");
//       } finally {
//         setIsSubmitting(false);
//       }
//     },
//   });

//   // --- Event Handlers ---

//   const handleInputChange = (id: number, field: keyof TableRowData, value: any) => {
//     setTableData((prevTableData) =>
//       prevTableData.map((row) =>
//         row.id === id ? { ...row, [field]: value } : row
//       )
//     );
//   };

//   const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const isChecked = event.target.checked;
//     setTableData((prevTableData) =>
//       prevTableData.map((row) => ({ ...row, isSelected: isChecked }))
//     );
//   };

//   const handleActionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setSelectedAction((event.target as HTMLInputElement).value);
//     // Reset selection when action changes? Optional.
//     // setTableData(prev => prev.map(row => ({ ...row, isSelected: false })));
//   };

//   // Calculate if all rows are selected (for the header checkbox)
//   const numSelected = tableData.filter((row) => row.isSelected).length;
//   const rowCount = tableData.length;
//   const isAllSelected = rowCount > 0 && numSelected === rowCount;

//   // --- Render ---

//   return (
//     <Box sx={{ p: 3, backgroundColor: 'background.default', minHeight: 'calc(100vh - 64px)' }}> {/* Adjust minHeight based on AppBar height */}
//       <ToastApp />
//       <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//         <Box
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             p: 2,
//             bgcolor: 'primary.main', // Or use theme color
//             color: 'primary.contrastText', // Or use theme color
//             // backgroundColor: 'var(--header-background)', // Use CSS var if defined globally
//             // color: 'var(--header-color)', // Use CSS var if defined globally
//           }}
//         >
//           <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
//             {t("text.UpdatePdf")}
//           </Typography>
//           <Button
//             variant="outlined" // Changed for better contrast on colored background
//             size="small"
//             onClick={() => navigate(-1)}
//             startIcon={<ArrowBackSharpIcon />}
//             sx={{
//               borderColor: 'primary.contrastText',
//               color: 'primary.contrastText',
//               '&:hover': {
//                 bgcolor: 'primary.dark', // Adjust hover effect
//                 borderColor: 'primary.contrastText',
//               }
//             }}
//           >
//             {t("text.Back")}
//           </Button>
//         </Box>

//         <CardContent sx={{ p: 3 }}>
//           <form onSubmit={formik.handleSubmit}>
//             <Grid container spacing={3}>
//               {/* --- Controls Section --- */}
//               <Grid item xs={12} md={4}>
//                 <Autocomplete
//                   id="doc-type-autocomplete"
//                   options={docTypeOptions}
//                   getOptionLabel={(option) => option.label}
//                   value={
//                     docTypeOptions.find(
//                       (option) => option.value === formik.values.docID.toString()
//                     ) || null
//                   }
//                   onChange={(_, newValue) => {
//                     const newId = newValue ? parseInt(newValue.value) : -1;
//                     formik.setFieldValue("docID", newId);
//                     // Automatically fetch documents when a type is selected
//                     // Or keep the separate search button if preferred
//                     if (newId !== -1) {
//                       fetchDocuments(newId); // Fetch immediately
//                     } else {
//                       setTableData([]); // Clear table if selection is cleared
//                     }
//                   }}
//                   loading={isLoadingDocTypes}
//                   disabled={isLoadingDocTypes || isSubmitting || isLoadingDocs}
//                   fullWidth
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={t("text.SelectDocType")}
//                       error={formik.touched.docID && Boolean(formik.errors.docID)}
//                       helperText={formik.touched.docID && formik.errors.docID}
//                       InputProps={{
//                         ...params.InputProps,
//                         endAdornment: (
//                           <>
//                             {isLoadingDocTypes ? <CircularProgress color="inherit" size={20} /> : null}
//                             {params.InputProps.endAdornment}
//                           </>
//                         ),
//                       }}
//                     />
//                   )}
//                 />
//               </Grid>

//               <Grid item xs={12} md={5}>
//                 <FormControl component="fieldset" disabled={isSubmitting || isLoadingDocs}>
//                   {/* <FormLabel component="legend">{t("text.SelectAction")}</FormLabel> */}
//                   <RadioGroup
//                     row
//                     aria-label="update-action"
//                     name="action-radio-group"
//                     value={selectedAction}
//                     onChange={handleActionChange}
//                   >
//                     <FormControlLabel
//                       value="rename" // Use simple value
//                       control={<Radio />}
//                       label={t("text.ForRename")} // Keep using translation key
//                     />
//                     <FormControlLabel
//                       value="shift" // Use simple value
//                       control={<Radio />}
//                       label={t("text.ForShiftCategory")} // Keep using translation key
//                     // disabled // Disable until implemented
//                     />
//                     {/* Add more actions here if needed */}
//                   </RadioGroup>
//                 </FormControl>
//               </Grid>

//               {/* Keep Search Button if explicit trigger is desired */}
//               {/* <Grid item xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Button
//                   onClick={() => fetchDocuments(formik.values.docID)}
//                   variant="contained"
//                   fullWidth
//                   disabled={formik.values.docID < 0 || isLoadingDocs || isSubmitting || isLoadingDocTypes}
//                   startIcon={isLoadingDocs ? <CircularProgress size={20} color="inherit" /> : null}
//                   sx={{ height: '56px' }} // Match TextField height
//                 >
//                   {isLoadingDocs ? t("text.loading") : t("text.search")}
//                 </Button>
//               </Grid> */}

//               {/* --- Table Section --- */}
//               <Grid item xs={12}>
//                 <Divider sx={{ my: 2 }} />
//                 {isLoadingDocs ? (
//                   <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
//                     <CircularProgress />
//                   </Box>
//                 ) : tableData.length === 0 && formik.values.docID !== -1 ? (
//                   <Alert severity="info" sx={{ mt: 2 }}>{t("text.noDocumentsFoundForType")}</Alert>
//                 ) : tableData.length === 0 && formik.values.docID === -1 ? (
//                   <Alert severity="info" sx={{ mt: 2 }}>{t("text.selectTypeToViewDocs")}</Alert>
//                 ) : (
//                   <TableContainer component={Paper} elevation={1} sx={{ maxHeight: '50vh' }}> {/* Added max height and scroll */}
//                     <Table stickyHeader aria-label="document update table">
//                       <TableHead>
//                         <TableRow sx={{ '& th': { backgroundColor: 'grey.200', fontWeight: 'bold' } }}>
//                           <TableCell padding="checkbox">
//                             <Checkbox
//                               color="primary"
//                               indeterminate={numSelected > 0 && numSelected < rowCount}
//                               checked={isAllSelected}
//                               onChange={handleSelectAll}
//                               inputProps={{ 'aria-label': 'select all documents' }}
//                               disabled={isSubmitting || isLoadingDocs}
//                             />
//                           </TableCell>
//                           <TableCell>{t("text.FileNo")}</TableCell>
//                           <TableCell>{t("text.PdfFileName")}</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {tableData.map((row) => (
//                           <TableRow
//                             hover
//                             key={row.id} // Use a unique key
//                             role="checkbox"
//                             aria-checked={row.isSelected}
//                             selected={row.isSelected}
//                             sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
//                           >
//                             <TableCell padding="checkbox">
//                               <Checkbox
//                                 color="primary"
//                                 checked={row.isSelected}
//                                 onChange={(e) => handleInputChange(row.id, "isSelected", e.target.checked)}
//                                 inputProps={{ 'aria-labelledby': `checkbox-label-${row.id}` }}
//                                 disabled={isSubmitting || isLoadingDocs}
//                               />
//                             </TableCell>
//                             <TableCell component="th" id={`checkbox-label-${row.id}`} scope="row">
//                               {row.fileNo}
//                             </TableCell>
//                             <TableCell>
//                               <TextField
//                                 variant="outlined" // Or 'standard' for less visual clutter
//                                 size="small"
//                                 fullWidth
//                                 type="text"
//                                 value={row.fileDef}
//                                 onChange={(e) => handleInputChange(row.id, "fileDef", e.target.value)}
//                                 disabled={!row.isSelected || selectedAction !== 'rename' || isSubmitting || isLoadingDocs} // Only enable if selected and action is rename
//                                 sx={{
//                                   backgroundColor: row.isSelected && selectedAction === 'rename' ? 'white' : 'grey.100', // Visual cue
//                                   minWidth: '250px' // Ensure enough space
//                                 }}
//                               />
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 )}
//               </Grid>

//               {/* --- Action Buttons Section --- */}
//               {tableData.length > 0 && ( // Only show buttons if there's data
//                 <Grid item xs={12} container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
//                   <Grid item xs={12} sm={4} md={3}>
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       color="primary"
//                       fullWidth
//                       disabled={isSubmitting || isLoadingDocs || numSelected === 0}
//                       startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
//                     >
//                       {isSubmitting ? t("text.saving") : t("text.save")}
//                     </Button>
//                   </Grid>
//                   <Grid item xs={12} sm={4} md={3}>
//                     <Button
//                       type="reset" // Resets formik state, not table selection easily
//                       variant="outlined"
//                       color="secondary" // Use theme color
//                       fullWidth
//                       disabled={isSubmitting || isLoadingDocs}
//                       onClick={() => {
//                         formik.resetForm(); // Reset doc type selection
//                         setTableData([]); // Clear table
//                         setSelectedAction('rename'); // Reset action
//                       }}
//                     // sx={{ backgroundColor: '#F43F5E', color: 'white' }} // Avoid hardcoding if possible
//                     >
//                       {t("text.reset")}
//                     </Button>
//                   </Grid>
//                 </Grid>
//               )}
//             </Grid>
//           </form>
//         </CardContent>
//       </Paper>
//     </Box>
//   );
// };

// export default UpdatePDF;





import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Paper,
  CircularProgress,
  Alert,
  Collapse,
  IconButton,
  TablePagination,
  InputAdornment,
  AlertTitle,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { getSecureDevId, getSecureSubDeptId } from "../../../utils/storageHelpers";
import { secureGetItem } from "../../../utils/encryption";

// --- Types and Interfaces ---
interface DocumentData {
  docMid: number;
  fileNo: string;
  fileDef: string;
  synopsis: string;
  fDate: string;
  complt: string | null;
  fileType: string | null;
  fileType_Name: string;
  divisionid: number;
  department_Name: string;
  fileTypId: number;
}

interface AutoCompleteOption {
  label: string;
  value: number | string;
}

interface Department {
  id: number;
  nodeID: number;
  name: string;
  titleID: number;
}

interface SubDepartment {
  subDeptID: number;
  subDeptName: string;
  deptID: number;
}

interface TableRowData {
  id: number;
  fileNo: string;
  docMid: number;
  fileDef: string;
  isSelected: boolean;
}

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
  isView: boolean;
}

// Validation schema
// const validationSchema = Yup.object({
//   docID: Yup.number()
//     .min(0, "Document Type is required")
//     .required("Document Type is required"),
// });

const UpdatePDF: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // --- Secure ID ---
  const devId = getSecureDevId();
  const subDeptID = getSecureSubDeptId();
  
  const devIdNum = devId !== -1 ? devId : -1;
  const subDeptIDNum = subDeptID !== -1 ? subDeptID : -1;
  
  const isDevIdPresent = devIdNum !== -1;
  const areBothSecureIdsPresent = devIdNum !== -1 && subDeptIDNum !== -1;
  const isDevIdOnlyPresent = devIdNum !== -1 && subDeptIDNum === -1;
  
  const [allDocumentsMaster, setAllDocumentsMaster] = useState<DocumentData[]>([]);
  
  // --- State Variables ---
  const [tableData, setTableData] = useState<TableRowData[]>([]);
  const [filteredData, setFilteredData] = useState<TableRowData[]>([]);
  const [isLoadingDocs, setIsLoadingDocs] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isLoadingDocTypes, setIsLoadingDocTypes] = useState<boolean>(false);
  const [permissionLoaded, setPermissionLoaded] = useState(false);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
    isView: false,
  });

  // --- Pagination State ---
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // --- Search State ---
  const [searchQuery, setSearchQuery] = useState("");

  // --- Filter States ---
  const [filtersExpanded, setFiltersExpanded] = useState(true);
  
  // Options for dropdowns
  const [docTypeOptions, setDocTypeOptions] = useState<AutoCompleteOption[]>([]);
  const [synopsisOptions, setSynopsisOptions] = useState<AutoCompleteOption[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<AutoCompleteOption[]>([]);
  const [subDepartmentOptions, setSubDepartmentOptions] = useState<AutoCompleteOption[]>([]);
  const [fileNoOptions, setFileNoOptions] = useState<AutoCompleteOption[]>([]);

  // Selected filter values
  const [selectedDocType, setSelectedDocType] = useState<AutoCompleteOption | null>(null);
  const [selectedSynopsis, setSelectedSynopsis] = useState<AutoCompleteOption | null>(null);
  const [selectedDepartment, setSelectedDepartment] = useState<AutoCompleteOption | null>(null);
  const [selectedSubDepartment, setSelectedSubDepartment] = useState<AutoCompleteOption | null>(null);
  const [selectedFileNo, setSelectedFileNo] = useState<AutoCompleteOption | null>(null);

  // ✅ Track which files have been edited
  const [editedFileIds, setEditedFileIds] = useState<Set<number>>(new Set());

  // Loading states
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [loadingSubDepartments, setLoadingSubDepartments] = useState(false);

  // Refs
  const initialSetupDone = useRef(false);
  const initialDataFetched = useRef(false);

  useEffect(() => {
    const data = secureGetItem("userdata");

    if (data && data.length > 0) {
      const userPermissionData = data[0]?.userPermission;
      const menudata = userPermissionData?.[0]?.parentMenu || [];

      for (let i = 0; i < menudata.length; i++) {
        const childMenudata = menudata[i]?.childMenu || [];
        const pathrow = childMenudata.find(
          (x: any) => x.path === location.pathname
        );

        if (pathrow) {
          setPermissionData({
            isAdd: pathrow.isAdd,
            isEdit: pathrow.isEdit,
            isPrint: pathrow.isPrint,
            isDel: pathrow.isDel,
            isView: pathrow.isView || false,
          });
          break;
        }
      }
    }
    setPermissionLoaded(true);
  }, [location.pathname]);

  const fetchAllDocumentsMaster = async () => {
    try {
      const response = await axios.post<{ data: DocumentData[] }>(
        HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
        {
          docMid: -1,
          fileTypId: -1,
          divisionid: -1,
          subDeptID: -1,
          subsubjId: -1,
          user_Id: -1,
          fileNo: "",
          synopsis: "",
          complt: "",
        }
      );

      const documents = response.data.data || [];
      setAllDocumentsMaster(documents);
      generateAutoCompleteOptions(documents);
    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  };

  // --- Formik ---
  const formik = useFormik({
    initialValues: {
      docID: -1,
    },
    // validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!permissionData?.isAdd) {
        toast.error("You don't have permission to update PDFs");
        return;
      }
      setIsSubmitting(true);

      const selectedFiles = tableData.filter((row) => row.isSelected);

      if (selectedFiles.length === 0) {
        toast.warn("No file selected");
        setIsSubmitting(false);
        return;
      }

      const payload = {
        udatePdfFiles: selectedFiles.map((row) => ({
          docID: row.docMid,
          doc_Name: row.fileDef,
        })),
      };
      
      try {
        const response = await axios.post(
          HOST_URL.HOST_URL2 + `DocMangr/UpdatePdfFileName`,
          payload
        );
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          setTableData((prev) =>
            prev.map((row) => ({ ...row, isSelected: false }))
          );
          setFilteredData((prev) =>
            prev.map((row) => ({ ...row, isSelected: false }))
          );
          setEditedFileIds(new Set());
          
          setSelectedSynopsis(null);
          setSearchQuery(""); 
          // ✅ Update dropdown options after successful save
          updateSynopsisOptions();
          
          fetchDocuments();
        } else {
          toast.error(response.data.mesg);
        }
      } catch (error) {
        console.error("Error submitting update:", error);
        toast.error("Update Failed");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  // --- Filter Change Handlers ---
  const handleDocTypeChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSelectedDocType(newValue);
    formik.setFieldValue("docID", newValue ? Number(newValue.value) : -1);
  };

  const handleSynopsisChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSelectedSynopsis(newValue);
  };

  const handleDepartmentChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    // Only allow department change if devId is not present
    if (!isDevIdPresent) {
      setSelectedDepartment(newValue);
      // Reset sub-department when department changes
      setSelectedSubDepartment(null);
      setSubDepartmentOptions([]);
    }
  };

  const handleSubDepartmentChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    // Only allow sub-department change if both secure IDs are not present
    if (!areBothSecureIdsPresent) {
      setSelectedSubDepartment(newValue);
    }
  };

  const handleFileNoChange = (event: React.SyntheticEvent, newValue: AutoCompleteOption | null) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSelectedFileNo(newValue);
  };

  const toggleFilters = () => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setFiltersExpanded(!filtersExpanded);
  };

  const handleResetFilters = () => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSelectedDocType(null);
    setSelectedSynopsis(null);
    setSelectedFileNo(null);
    setSearchQuery("");
    setEditedFileIds(new Set());
    
    // Only reset department and sub-department if secure IDs are not present
    if (!isDevIdPresent) {
      setSelectedDepartment(null);
      setSelectedSubDepartment(null);
      setSubDepartmentOptions([]);
    } else if (isDevIdOnlyPresent) {
      // If only devId is present, keep department selected but reset sub-department
      setSelectedSubDepartment(null);
    }
    
    formik.setFieldValue("docID", -1);
  };

  // --- Search Handler ---
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!permissionData?.isView) {
      toast.error("You don't have view permission");
      return;
    }
    setSearchQuery(event.target.value);
    setPage(0);
  };

  // --- Pagination Handlers ---
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // --- Get current page data ---
  const paginatedData = useMemo(() => {
    const start = page * rowsPerPage;
    const end = start + rowsPerPage;
    return filteredData.slice(start, end);
  }, [filteredData, page, rowsPerPage]);

  // --- API Functions ---
  const fetchDocTypes = useCallback(async (deptId = -1) => {
    if (!permissionData?.isView) return;
    setIsLoadingDocTypes(true);
    const collectData = { 
      docID: -1, 
      parentDocId: deptId, // Department ID as parentDocId
      userId: "" 
    };

    try {
      const response = await axios.post<{ data: any[] }>(
        HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`,
        collectData
      );

      const docTypes = response.data.data || [];
      const options = docTypes.map((item: any) => ({
        label: item["doc_Name"],
        value: item["docID"]
      }));

      setDocTypeOptions(options);
    } catch (error) {
      console.error("Error fetching doc types:", error);
      toast.error("Failed to fetch document types.");
    } finally {
      setIsLoadingDocTypes(false);
    }
  }, [permissionData?.isView]);

  const fetchDepartments = useCallback(async () => {
    if (!permissionData?.isView) return;
    setLoadingDepartments(true);
    const collectData = { 
      id: isDevIdPresent ? devIdNum : -1, 
      nodeID: -1, 
      titleID: -1 
    };

    try {
      const response = await axios.post<{ data: Department[] }>(
        HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`,
        collectData
      );

      const departments = response.data.data || [];
      const options = departments.map((dept: Department) => ({
        label: dept.name,
        value: dept.id
      }));

      setDepartmentOptions(options);

      // If devId is present, set the department immediately
      if (isDevIdPresent) {
        const foundDept = options.find(dept => dept.value === devIdNum);
        if (foundDept) {
          setSelectedDepartment(foundDept);
          // Fetch sub-departments for this department
          await fetchSubDepartments(devIdNum, true);
        }
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      toast.error("Failed to fetch departments.");
    } finally {
      setLoadingDepartments(false);
    }
  }, [isDevIdPresent, devIdNum, permissionData?.isView]);

  const fetchSubDepartments = useCallback(async (deptId: number, isInitialSetup: boolean = false) => {
    if (!permissionData?.isView) return;
    if (deptId === -1) {
      setSubDepartmentOptions([]);
      return;
    }

    setLoadingSubDepartments(true);
    try {
      const response = await axios.post<{ data: SubDepartment[] }>(
        HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`,
        {
          subDeptID: -1,
          deptID: deptId
        }
      );

      const subDepartments = response.data.data || [];
      const options = subDepartments.map((subDept: SubDepartment) => ({
        label: subDept.subDeptName,
        value: subDept.subDeptID
      }));

      setSubDepartmentOptions(options);

      // If this is initial setup and both secure IDs are present, find and set the sub-department
      if (isInitialSetup && areBothSecureIdsPresent && subDeptIDNum !== -1) {
        const foundSubDept = options.find(subDept => subDept.value === subDeptIDNum);
        if (foundSubDept) {
          setSelectedSubDepartment(foundSubDept);
        }
      }
    } catch (error) {
      console.error("Error fetching sub-departments:", error);
      toast.error("Failed to fetch sub-departments.");
      setSubDepartmentOptions([]);
    } finally {
      setLoadingSubDepartments(false);
    }
  }, [areBothSecureIdsPresent, subDeptIDNum, permissionData?.isView]);

  const fetchDocuments = useCallback(async () => {
    if (!permissionData?.isView) return;
    setIsLoadingDocs(true);

    const collectData = {
      docMid: -1,
      fileTypId: selectedDocType ? Number(selectedDocType.value) : -1,
      divisionid: isDevIdPresent
        ? devIdNum
        : selectedDepartment
          ? Number(selectedDepartment.value)
          : -1,
      subDeptID: (isDevIdPresent && selectedSubDepartment)
        ? Number(selectedSubDepartment.value)
        : (isDevIdPresent && areBothSecureIdsPresent)
          ? subDeptIDNum
          : selectedSubDepartment
            ? Number(selectedSubDepartment.value)
            : -1,
      subsubjId: -1,
      user_Id: -1,
      fileNo: selectedFileNo ? String(selectedFileNo.value) : "",
      synopsis: selectedSynopsis ? String(selectedSynopsis.value) : "",
      complt: "",
    };

    try {
      const response = await axios.post<{ data: DocumentData[] }>(
        HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
        collectData
      );

      const documents = response.data.data || [];

      // Format data for table
      const formattedData: TableRowData[] = documents.map(
        (item: DocumentData, index: number) => ({
          id: item["docMid"] || index,
          fileNo: item["fileNo"],
          docMid: item["docMid"],
          fileDef: item["fileDef"],
          isSelected: false,
        })
      );
      
      setTableData(formattedData);
      setFilteredData(formattedData);
      setEditedFileIds(new Set());
      setPage(0);
      
      // ✅ Update dropdown options with latest data
      updateSynopsisOptions();
    } catch (error) {
      console.error("Error fetching documents:", error);
      toast.error("Failed to fetch documents.");
      setTableData([]);
      setFilteredData([]);
    } finally {
      setIsLoadingDocs(false);
    }
  }, [
    selectedDocType,
    selectedSynopsis,
    selectedDepartment,
    selectedSubDepartment,
    selectedFileNo,
    isDevIdPresent,
    devIdNum,
    areBothSecureIdsPresent,
    subDeptIDNum,
    permissionData?.isView,
  ]);

  // ✅ New function to update synopsis options from table data
  const updateSynopsisOptions = useCallback(() => {
    const currentData = tableData.length > 0 ? tableData : filteredData;
    const synopses = Array.from(new Set(
      currentData
        .map(item => item.fileDef)
        .filter(Boolean)
    )).map(fileDef => ({
      label: fileDef as string,
      value: fileDef as string
    }));
    setSynopsisOptions(synopses);
  }, [tableData, filteredData]);

  const generateAutoCompleteOptions = useCallback((documents: DocumentData[]) => {
    // Synopsis Options
    const synopses = Array.from(new Set(documents
      .map(doc => doc.synopsis)
      .filter(Boolean)))
      .map(synopsis => ({
        label: synopsis as string,
        value: synopsis as string
      }));
    setSynopsisOptions(synopses);

    // File No Options
    const fileNos = Array.from(new Set(documents
      .map(doc => doc.fileNo)
      .filter(Boolean)))
      .map(fileNo => ({
        label: fileNo as string,
        value: fileNo as string
      }));
    setFileNoOptions(fileNos);
  }, []);

  // --- FIXED: Filter by Synopsis (Filename) and Search ---
  useEffect(() => {
    if (!permissionData?.isView) return;
    if (tableData.length > 0) {
      let filtered = [...tableData];
      
      // ✅ Apply synopsis/filename filter - but ignore edited files
      if (selectedSynopsis && selectedSynopsis.value) {
        filtered = filtered.filter(item => {
          // If file is edited, keep it visible regardless of filter
          if (editedFileIds.has(item.id)) {
            return true;
          }
          // Otherwise check if it matches the filter
          return item.fileDef && item.fileDef.toLowerCase().includes(String(selectedSynopsis.value).toLowerCase());
        });
      }
      
      // Apply global search query (free text)
      if (searchQuery) {
        filtered = filtered.filter(item => 
          (item.fileNo && item.fileNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (item.fileDef && item.fileDef.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      }
      
      // ✅ Preserve selection and edited values
      setFilteredData(prev => {
        const currentMap = new Map(prev.map(row => [row.id, row]));
        
        return filtered.map(row => {
          const currentRow = currentMap.get(row.id);
          return currentRow ? { 
            ...row, 
            isSelected: currentRow.isSelected,
            fileDef: currentRow.fileDef // Preserve edited filename
          } : row;
        });
      });
      
      setPage(0);
    } else {
      setFilteredData([]);
    }
  }, [selectedSynopsis, searchQuery, tableData, permissionData?.isView, editedFileIds]);

  // ✅ Update dropdown options when tableData changes
  useEffect(() => {
    if (tableData.length > 0) {
      updateSynopsisOptions();
    }
  }, [tableData, updateSynopsisOptions]);

  // Fetch sub-departments when department changes (only if secure IDs are not present)
  useEffect(() => {
    if (!initialSetupDone.current || !permissionData?.isView) return;

    // Only fetch sub-departments if department is selected AND no secure IDs are controlling it
    if (selectedDepartment && !isDevIdPresent) {
      fetchSubDepartments(Number(selectedDepartment.value));
    } else if (!isDevIdPresent && initialSetupDone.current && !selectedDepartment) {
      // If no department is selected and secure IDs are not present, clear sub-department options
      setSubDepartmentOptions([]);
      setSelectedSubDepartment(null);
    }
  }, [selectedDepartment?.value, isDevIdPresent, initialSetupDone.current, permissionData?.isView, fetchSubDepartments]);

  // --- useEffect Hooks ---
  useEffect(() => {
    const initData = async () => {
      if (!permissionData?.isView) return;
      if (initialSetupDone.current) return;
      
      try {
        await fetchDepartments();
        
        // Fetch doc types with department ID
        let deptId = -1;
        if (isDevIdPresent) {
          deptId = devIdNum;
        }
        await fetchDocTypes(deptId);
        
        await fetchAllDocumentsMaster(); 
        initialSetupDone.current = true;
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    initData();
  }, [fetchDepartments, fetchDocTypes, permissionData?.isView, isDevIdPresent, devIdNum]);

  // Fetch documents when department or sub-department changes
  useEffect(() => {
    if (!permissionData?.isView) return;
    if (!initialSetupDone.current || initialDataFetched.current) return;

    const timer = setTimeout(() => {
      fetchDocuments();
      initialDataFetched.current = true;
    }, 300);

    return () => clearTimeout(timer);
  }, [initialSetupDone.current, fetchDocuments, permissionData?.isView]);

  // Fetch documents when filters change (except department and sub-department which are handled separately)
  useEffect(() => {
    if (!permissionData?.isView) return;
    if (!initialDataFetched.current) return;

    const timer = setTimeout(() => {
      fetchDocuments();
    }, 500);

    return () => clearTimeout(timer);
  }, [
    selectedDocType?.value,
    selectedFileNo?.value,
    fetchDocuments,
    permissionData?.isView,
  ]);

  // Fetch documents when department or sub-department changes
  useEffect(() => {
    if (!permissionData?.isView) return;
    if (!initialDataFetched.current) return;

    const timer = setTimeout(() => {
      fetchDocuments();
      // Also fetch doc types when department changes
      let deptId = -1;
      if (isDevIdPresent) {
        deptId = devIdNum;
      } else if (selectedDepartment) {
        deptId = Number(selectedDepartment.value);
      }
      fetchDocTypes(deptId);
    }, 500);

    return () => clearTimeout(timer);
  }, [
    selectedDepartment?.value,
    selectedSubDepartment?.value,
    fetchDocuments,
    fetchDocTypes,
    permissionData?.isView,
    isDevIdPresent,
    devIdNum,
  ]);

  // --- FIXED: Event Handlers for Table ---
  const handleInputChange = (id: number, field: keyof TableRowData, value: any) => {
    if (!permissionData?.isAdd) {
      toast.error("You don't have permission to edit");
      return;
    }
    
    // ✅ Track that this file has been edited
    if (field === 'fileDef') {
      setEditedFileIds(prev => new Set(prev).add(id));
      
      // ✅ Update dropdown options immediately when filename changes
      setTableData(prev => {
        const updated = prev.map((row) => (row.id === id ? { ...row, [field]: value } : row));
        // Update synopsis options from updated data
        const synopses = Array.from(new Set(
          updated
            .map(item => item.fileDef)
            .filter(Boolean)
        )).map(fileDef => ({
          label: fileDef as string,
          value: fileDef as string
        }));
        setSynopsisOptions(synopses);
        return updated;
      });
      
      // Update filteredData
      setFilteredData(prev => 
        prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
      );
    } else {
      // For other fields (like isSelected)
      setTableData((prev) => 
        prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
      );
      
      setFilteredData((prev) => 
        prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
      );
    }
  };

  // --- FIXED: Handle Select All ---
  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!permissionData?.isAdd) {
      toast.error("You don't have permission to select");
      return;
    }
    const isChecked = event.target.checked;
    
    // Get all IDs from filtered data
    const filteredIds = new Set(filteredData.map(row => row.id));
    
    // Update main table data - only for rows that are in filtered data
    setTableData((prev) => 
      prev.map((row) => 
        filteredIds.has(row.id) ? { ...row, isSelected: isChecked } : row
      )
    );
    
    // Update filtered data
    setFilteredData((prev) => 
      prev.map((row) => ({ ...row, isSelected: isChecked }))
    );
  };

  // Check if a row is selected (for header checkbox)
  const numSelected = filteredData.filter((row) => row.isSelected).length;
  const rowCount = filteredData.length;
  const isAllSelected = rowCount > 0 && numSelected === rowCount;

  // Function to get appropriate placeholder text for sub-department
  const getSubDepartmentPlaceholder = useCallback(() => {
    if (areBothSecureIdsPresent) {
      return "Pre-selected from secure ID";
    } else if (isDevIdOnlyPresent) {
      return "Select sub-department (optional)";
    } else if (selectedDepartment) {
      return "Select sub-department";
    } else {
      return "Select department first";
    }
  }, [areBothSecureIdsPresent, isDevIdOnlyPresent, selectedDepartment]);

  return (
    <Box sx={{ p: 3, backgroundColor: 'background.default', minHeight: 'calc(100vh - 64px)' }}>
      <ToastApp />
      <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
            {t("text.UpdatePdf")}
          </Typography>
          <Button variant="outlined" size="small" onClick={() => navigate(-1)} startIcon={<ArrowBackSharpIcon />} sx={{ borderColor: 'primary.contrastText', color: 'primary.contrastText', '&:hover': { bgcolor: 'primary.dark' } }}>
            {t("text.Back")}
          </Button>
        </Box>

        <CardContent sx={{ p: 3 }}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              {/* Filters Section */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ mb: 2 }}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }} onClick={toggleFilters}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <FilterListIcon sx={{ mr: 1, fontSize: 20 }} />
                        <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 500 }}>Filters</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button variant="outlined" size="small" onClick={(e) => { e.stopPropagation(); handleResetFilters(); }} sx={{ mr: 1, minWidth: 'auto', px: 1.5 }}>Reset</Button>
                        <IconButton size="small">{filtersExpanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
                      </Box>
                    </Box>

                    <Collapse in={filtersExpanded}>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        {/* 1. Department Filter */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Autocomplete
                            options={departmentOptions}
                            value={selectedDepartment}
                            onChange={handleDepartmentChange}
                            getOptionLabel={(option) => option.label}
                            loading={loadingDepartments}
                            disabled={isDevIdPresent}
                            size="small"
                            renderInput={(params) => (
                              <TextField 
                                {...params} 
                                label="Department" 
                                placeholder={isDevIdPresent ? "Pre-selected from secure ID" : "Select department"} 
                                InputProps={{ 
                                  ...params.InputProps, 
                                  endAdornment: ( 
                                    <> 
                                      {loadingDepartments ? <CircularProgress size={18} /> : null} 
                                      {params.InputProps.endAdornment} 
                                    </> 
                                  ) 
                                }} 
                              />
                            )}
                          />
                        </Grid>

                        {/* 2. Sub-Department Filter */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Autocomplete
                            options={subDepartmentOptions}
                            value={selectedSubDepartment}
                            onChange={handleSubDepartmentChange}
                            getOptionLabel={(option) => option.label}
                            loading={loadingSubDepartments}
                            disabled={!selectedDepartment || areBothSecureIdsPresent || loadingSubDepartments}
                            size="small"
                            renderInput={(params) => (
                              <TextField 
                                {...params} 
                                label="Sub-Department" 
                                placeholder={getSubDepartmentPlaceholder()}
                                InputProps={{ 
                                  ...params.InputProps, 
                                  endAdornment: ( 
                                    <> 
                                      {loadingSubDepartments ? <CircularProgress size={18} /> : null} 
                                      {params.InputProps.endAdornment} 
                                    </> 
                                  ) 
                                }} 
                              />
                            )}
                          />
                        </Grid>

                        {/* 3. Document Type Filter */}
                        {/* <Grid item xs={12} sm={6} md={3}>
                          <Autocomplete
                            options={docTypeOptions}
                            value={selectedDocType}
                            onChange={handleDocTypeChange}
                            getOptionLabel={(option) => option.label}
                            loading={isLoadingDocTypes}
                            size="small"
                            renderInput={(params) => (
                              <TextField 
                                {...params} 
                                label="Document Type" 
                                placeholder="Select document type"
                                error={formik.touched.docID && Boolean(formik.errors.docID)}
                                helperText={formik.touched.docID && formik.errors.docID}
                                InputProps={{ 
                                  ...params.InputProps, 
                                  endAdornment: ( 
                                    <> 
                                      {isLoadingDocTypes ? <CircularProgress size={18} /> : null} 
                                      {params.InputProps.endAdornment} 
                                    </> 
                                  ) 
                                }} 
                              />
                            )}
                          />
                        </Grid> */}

                        {/* 4. File Name (Synopsis) Filter */}
                        <Grid item xs={12} sm={6} md={4}>
                          <Autocomplete
                            options={synopsisOptions}
                            value={selectedSynopsis}
                            onChange={handleSynopsisChange}
                            getOptionLabel={(option) => option.label}
                            size="small"
                            renderInput={(params) => (
                              <TextField {...params} label="File Name" placeholder="Select file name" />
                            )}
                          />
                        </Grid>

                        {/* 5. File No Filter - Moved to next row */}
                        {/* <Grid item xs={12} sm={6} md={3}>
                          <Autocomplete
                            options={fileNoOptions}
                            value={selectedFileNo}
                            onChange={handleFileNoChange}
                            getOptionLabel={(option) => option.label}
                            size="small"
                            renderInput={(params) => (
                              <TextField {...params} label="File No" placeholder="Select file number" />
                            )}
                          />
                        </Grid> */}
                      </Grid>
                    </Collapse>
                  </CardContent>
                </Card>
              </Grid>

              {/* Global Search Bar - Above Table */}
              <Grid item xs={12} sx={{ mt: -1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Global Search by File No or File Name..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    sx={{ width: '350px' }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Grid>

              {/* Table Section */}
              <Grid item xs={12} sx={{ mt: -2 }}>
                
                {isLoadingDocs ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}><CircularProgress /></Box>
                ) : filteredData.length === 0 ? (
                  <Alert severity="info" sx={{ mt: 2 }}>Please wait, documents are loading...</Alert>
                ) : (
                  <>
                    <TableContainer component={Paper} elevation={1} sx={{ maxHeight: '50vh' }}>
                      <Table stickyHeader>
                        <TableHead>
                          {/* Table Headers */}
                          <TableRow sx={{ '& th': { backgroundColor: 'lightblue', fontWeight: 'bold' } }}>
                            <TableCell padding="checkbox">
                              {permissionData?.isAdd && (
                                <Checkbox 
                                  color="primary" 
                                  indeterminate={numSelected > 0 && numSelected < rowCount} 
                                  checked={isAllSelected} 
                                  onChange={handleSelectAll} 
                                  disabled={isSubmitting} 
                                />
                              )}
                            </TableCell>
                            <TableCell>File No</TableCell>
                            <TableCell>PDF File Name</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {paginatedData.map((row: TableRowData, index: number) => (
                            <TableRow 
                              hover 
                              key={row.id} 
                              selected={row.isSelected}
                              sx={{ 
                                backgroundColor: index % 2 === 0 ? '#fafafa' : '#ffffff',
                                '&:hover': {
                                  backgroundColor: '#f5f5f5 !important',
                                }
                              }}
                            >
                              <TableCell padding="checkbox">
                                {permissionData?.isAdd && (
                                  <Checkbox 
                                    color="primary" 
                                    checked={row.isSelected} 
                                    onChange={(e) => handleInputChange(row.id, "isSelected", e.target.checked)} 
                                    disabled={isSubmitting} 
                                  />
                                )}
                              </TableCell>
                              <TableCell>{row.fileNo}</TableCell>
                              <TableCell>
                                <TextField 
                                  variant="outlined" 
                                  size="small" 
                                  fullWidth 
                                  value={row.fileDef} 
                                  onChange={(e) => handleInputChange(row.id, "fileDef", e.target.value)} 
                                  disabled={!row.isSelected || isSubmitting || !permissionData?.isAdd} 
                                  sx={{ 
                                    backgroundColor: row.isSelected ? 'white' : 'transparent', 
                                    minWidth: '250px' 
                                  }} 
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {/* Pagination */}
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50, 100]}
                      component="div"
                      count={filteredData.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      labelRowsPerPage="Rows per page:"
                    />
                  </>
                )}
              </Grid>

              {/* Action Buttons */}
              {filteredData.length > 0 && permissionData?.isAdd && (
                <Grid item xs={12} container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                  <Grid item xs={12} sm={4} md={3}>
                    <Button type="submit" variant="contained" color="primary" fullWidth disabled={isSubmitting || numSelected === 0} startIcon={isSubmitting ? <CircularProgress size={20} /> : null}>
                      {isSubmitting ? "Saving..." : "Save"}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <Button type="reset" variant="outlined" color="secondary" fullWidth disabled={isSubmitting} onClick={() => { formik.resetForm(); handleResetFilters(); }}>
                      {t("text.reset")}
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </form>
        </CardContent>
      </Paper>
    </Box>
  );
};

export default UpdatePDF;